import { useMutation, useQueryClient } from '@tanstack/react-query';

import { setupMfa } from '../api/adminsApi';
import { ADMIN_ACCOUNTS_QUERY_KEY } from './useAdminAccounts';

// PARA-151, AC-1/AC-1.1: генерация TOTP-секрета для enrollment. Повторный
// вызов до подтверждения инвалидирует прежний секрет (backend).
export function useMfaSetup() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => setupMfa(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_ACCOUNTS_QUERY_KEY });
    },
  });
}
